import type { CSSProperties, ReactNode } from 'react'
import { radius } from './shape'

/** The primary action, in the one accent. */
export function PrimaryAction({
  children,
  href,
  onClick,
  compact = false,
  style,
}: {
  children: ReactNode
  href: string
  onClick?: () => void
  compact?: boolean
  style?: CSSProperties
}) {
  return (
    <a
      href={href}
      onClick={onClick}
      style={{
        padding: compact ? '9px 16px' : '15px 26px',
        borderRadius: compact ? radius.md : radius.action,
        background: 'var(--accent)',
        color: 'var(--ground)',
        fontSize: compact ? 13.5 : 15.5,
        fontWeight: 700,
        ...style,
      }}
    >
      {children}
    </a>
  )
}
